import DefaultMapper from '../../dataProvider/DefaultMapper';

class FeeDefinitionMapper extends DefaultMapper {

	mapResource({ resource }) {
		return 'system/fees/definitions';
	}

	prepareUpdate({ params, options }) {
		super.prepareUpdate(...arguments);
		const filteredParams = Object.assign({}, params.data);
		delete filteredParams.id;
		delete filteredParams.creationDateTime;
		delete filteredParams.subsidiaryId;
		// Start Workaround for CW-694
		filteredParams.validFromAmount = params.data.validFromAmount ? params.data.validFromAmount.amount : null;
		filteredParams.validUntilAmount = params.data.validUntilAmount ? params.data.validUntilAmount.amount : null;
		filteredParams.minAmount = params.data.minAmount ? params.data.minAmount.amount : null;
		filteredParams.maxAmount = params.data.maxAmount ? params.data.maxAmount.amount : null;
		filteredParams.baseAmount = params.data.baseAmount ? params.data.baseAmount.amount : null;
		// End Workaround for CW-694
		options.body = JSON.stringify(filteredParams);
	}
};

export default FeeDefinitionMapper;
